import {IEnvironment} from "./IEnvironment";

export const environment: IEnvironment = {
  adyen: {environment: 'test'},
  api: {
    url: 'https://api.bmw.teraone-preview.de/api/ticketshop/v1',
    session_domain: '.bmw.teraone-preview.de'
  },
  env_name: 'stage',
  production: false,
  version_update_method: "next_route",
  vehicle_consultation_nav_enabled: true,
  load_epaas: false,
}
